var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "invoice-tabs-parent", class: _vm.tabClasses },
    [
      _c(
        "div",
        { staticClass: "invoice-tabs-header app_tabs_header mb-5 font-outfit" },
        [
          _c(
            "ul",
            { staticClass: "invoice-tabs app_tabs_items flex justify-end" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "li",
                {
                  key: tab.name,
                  class: {
                    "px-3 py-2.5 cursor-pointer text-gray-400 text-lg flex items-center": true,
                    "invoice-active": _vm.activeTab === index,
                  },
                  on: {
                    mouseover: function ($event) {
                      tab.name === `Calendar`
                        ? (_vm.isHoveredCal = true)
                        : (_vm.isHoveredList = true)
                    },
                    mouseout: function ($event) {
                      tab.name === `List`
                        ? (_vm.isHoveredList = false)
                        : (_vm.isHoveredCal = false)
                    },
                    click: function ($event) {
                      return _vm.setActiveTab(index)
                    },
                  },
                },
                [
                  tab.name === `Calendar` &&
                  _vm.activeTab !== index &&
                  _vm.isHoveredCal
                    ? [_c("CalendarList", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  tab.name === `Calendar` &&
                  _vm.activeTab !== index &&
                  !_vm.isHoveredCal
                    ? [_c("CalendarListHover", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  tab.name === `Calendar` && _vm.activeTab === index
                    ? [_c("CalendarList", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  tab.name === `List` && _vm.activeTab === index
                    ? [_c("ListTableHover", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  tab.name === `List` &&
                  _vm.activeTab !== index &&
                  _vm.isHoveredList
                    ? [_c("ListTableHover", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  tab.name === `List` &&
                  _vm.activeTab !== index &&
                  !_vm.isHoveredList
                    ? [_c("ListTable", { staticClass: "w-4 h-4 mr-1" })]
                    : _vm._e(),
                  _vm._v(" " + _vm._s(tab.name) + " "),
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "tab-content" },
        [_vm._t("tab-" + _vm.activeTab)],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }